import React, { useRef } from "react";
import Input from "../Inputs/index";
import { CONSTANTS } from "../../constants/Constants";
import Select from "../Select";
import { CreateUserFormProps } from "../../types/users";

const CreateUserForm: React.FC<CreateUserFormProps> = ({
    change_handler,
    userData,
    fieldErrors = {},
    roleOptions,
    isEdit = false,
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    return (
        <div className="mt-4 space-y-4 w-">
            <div className="space-y-2">
                <label className="text-sm">
                    {CONSTANTS.NAME_TXT}
                    <span className="text-error mr-1">*</span>
                </label>
                <Input
                    input_name="name"
                    value={userData.name || ""}
                    change_handler={change_handler}
                    placeholder={CONSTANTS.ENTER_NAME_TXT}
                    other_classes="text-sm h-9 rounded-none"
                />
                {fieldErrors.Name && <small className="text-error">{fieldErrors.Name}</small>}
            </div>

            <div className="space-y-2">
                <label className="text-sm">
                    Email
                    <span className="text-error mr-1">*</span>
                </label>
                <Input
                    input_name="email"
                    type="email"
                    value={userData.email || ""}
                    change_handler={change_handler}
                    placeholder={CONSTANTS.ENTER_EMAIL_TXT}
                    other_classes="text-sm h-9 rounded-none"
                    is_disable={isEdit}
                />
                {fieldErrors.Email && <small className="text-error">{fieldErrors.Email}</small>}
            </div>

            <div className="space-y-2">
                <label className="text-sm">
                    Image
                </label>
                <div
                    className="w-full h-9 px-3 border border-[#E6E6E6] rounded text-sm bg-white cursor-pointer hover:border-[#666666] flex items-center relative"
                    onClick={() => fileInputRef.current?.click()}
                >
                    <input
                        ref={fileInputRef}
                        name="image"
                        type="file"
                        accept="image/*"
                        onChange={(e) => change_handler(e as any)}
                        className="hidden"
                    />

                    {userData.image ? (
                        <>
                            <img
                                src={typeof userData.image === 'string' ? userData.image : URL.createObjectURL(userData.image as File)}
                                alt="Preview"
                                className="w-6 h-6 object-cover rounded mr-2"
                            />
                            <span className="text-[#999999] truncate">
                                {typeof userData.image === 'string' ? CONSTANTS.CURRENT_IMAGE_TXT : (userData.image as File).name}
                            </span>
                        </>
                    ) : (
                        <span className="text-[#999999]">
                            {CONSTANTS.CHOOSE_FILE_TXT}
                        </span>
                    )}

                    {userData.image && (
                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                fileInputRef.current!.value = "";
                                change_handler({ target: { name: "image", value: null } } as any);
                            }}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                        >
                            ×
                        </button>
                    )}
                </div>

                {fieldErrors.Image && <small className="text-error">{fieldErrors.Image}</small>}
            </div>

            <div className="space-y-2">
                <label className="text-sm">
                    Role
                    <span className="text-error mr-1">*</span>
                </label>
                <Select
                    name="userRoleId"
                    options={roleOptions.map(role => ({ id: role.systemRoleId, name: role.systemRoleName }))}
                    handle_change={(e) => change_handler(e.target.value, "userRoleId")}
                    value={userData.selectedRole?.systemRoleId || ""}
                    firstOptionText={CONSTANTS.SELECT_ROLE_TXT}
                    other_classes="text-sm h-9 rounded-none"
                />
                {fieldErrors.UserRoleId && <small className="text-error">{fieldErrors.UserRoleId}</small>}
            </div>

            {isEdit && (
                <div className="space-y-2">
                    <label className="text-sm">
                        Status
                        <span className="text-error mr-1">*</span>
                    </label>
                    <Select
                        name="status"
                        options={[
                            { id: "ENABLED", name: CONSTANTS.ENABLED_TXT },
                            { id: "DISABLED", name: CONSTANTS.DISABLED_TXT }
                        ]}
                        handle_change={(e) => change_handler(e.target.value, "status")}
                        value={userData.status}
                        firstOptionText={CONSTANTS.SELECT_STATUS_TXT}
                        other_classes="text-sm h-9 rounded-none"
                    />
                    {fieldErrors.Status && <small className="text-error">{fieldErrors.Status}</small>}
                </div>
            )}
        </div>
    );
};

export default CreateUserForm;